module.exports = "/cyber/_next/static/images/mtsd-banner-desktop-3f4c6e3a3f7c93101376eecf1014224f.webp";